function UnsubscribeController($http) {
  "ngInject";
};

export default {
  name: 'unsubscribedCTRL',
  fn: UnsubscribeController
}